import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { currentModalStepAtom } from "../../atoms/stores";
import { AddOrReplacePlayerPrivateStep } from "../AddOrReplacePlayerPrivateStep/AddOrReplacePlayerPrivateStep";
import { AddPlayerStep } from "../AddPlayerStep/AddPlayerStep";
import { EditableRoundsStep } from "../EditableRoundsStep/EditableRoundsStep";
import { MovePlayerBetweenGroupsStep } from "../MovePlayerBetweenGroupsStep/MovePlayerBetweenGroupsStep";
import { ModalStepOutlet_Booking$key } from "./__generated__/ModalStepOutlet_Booking.graphql";

type Props = {
  bookingRef: ModalStepOutlet_Booking$key;
  onClose: () => void;
  onSaveSuccess: () => void;
  currentMembershipTypeId: string;
  currentSessionUserClientId: string;
  membersCanAddUnknownGuests: boolean;
  memberNonPlayingHostToggle: boolean;
};
export const ModalStepOutlet = ({
  bookingRef,
  onClose,
  onSaveSuccess,
  currentMembershipTypeId,
  currentSessionUserClientId,
  membersCanAddUnknownGuests,
  memberNonPlayingHostToggle,
}: Props) => {
  const booking = useFragment(ModalStepOutletFragmentString, bookingRef);
  const currentModalStep = useAtomValue(currentModalStepAtom);

  const isEditRoundsStep =
    currentModalStep.type === "EditRounds" ||
    currentModalStep.type === "EditRoundsPrivate";

  return (
    <>
      {isEditRoundsStep ? (
        <EditableRoundsStep
          bookingRef={booking}
          onClose={onClose}
          onSaveSuccess={onSaveSuccess}
          currentMembershipTypeId={currentMembershipTypeId}
          currentSessionUserClientId={currentSessionUserClientId}
        />
      ) : currentModalStep.type === "AddPlayerPrivate" ||
        currentModalStep.type === "ReplacePlayerPrivate" ||
        currentModalStep.type === "SwapPlayersPrivate" ? (
        <AddOrReplacePlayerPrivateStep
          bookingRef={booking}
          membersCanAddUnknownGuests={membersCanAddUnknownGuests}
          memberNonPlayingHostToggle={memberNonPlayingHostToggle}
        />
      ) : currentModalStep.type === "MovePlayerBetweenGroups" ? (
        <MovePlayerBetweenGroupsStep roundId={currentModalStep.roundId} />
      ) : (
        <AddPlayerStep
          bookingRef={booking}
          currentSessionUserClientId={currentSessionUserClientId}
        />
      )}
    </>
  );
};
const ModalStepOutletFragmentString = graphql`
  fragment ModalStepOutlet_Booking on Booking {
    ...EditableRoundsStep_Booking
    ...AddPlayerStep_Booking
    ...AddOrReplacePlayerPrivateStep_Booking
  }
`;
